import { useRouter } from 'expo-router';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { requestContentCardsRefresh } from 'services/engagement/braze/braze';
import { useAnalyticsConfiguration } from 'shared/hooks/analytics/useAnalyticsConfiguration';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import { useEngagement } from 'shared/hooks/useBraze';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';

interface WalletProvisioningSuccessScreenProps {
  analyticsCategory?: string;
  analyticsSubcategory?: string;
  isBelieveDay0Flow?: string;
  believeAccountId?: string;
}
const WalletProvisioningSuccessScreen = ({
  analyticsCategory,
  analyticsSubcategory,
  isBelieveDay0Flow,
  believeAccountId,
}: WalletProvisioningSuccessScreenProps) => {
  const router = useRouter();
  const { analyticsEvents } = useAnalyticsConfiguration();
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'cardManagement.walletProvisioningSuccess',
  });
  const { logCustomEvent, setRequestedCardId, requestedCard } = useEngagement();
  useEffect(() => {
    logCustomEvent('BRAZETRIGGER, wallet provisioning success screen viewed');
    requestContentCardsRefresh();
    setRequestedCardId?.('wallet_success_screen_offer');
  }, [logCustomEvent, setRequestedCardId]);
  const subcategory =
    isBelieveDay0Flow === 'true'
      ? 'wallet_provisioning_believe_day_0'
      : analyticsSubcategory;
  const analyticsContext =
    analyticsCategory && subcategory
      ? {
          category: analyticsCategory,
          subcategory: subcategory,
        }
      : null;
  const goBack = () => {
    void analyticsEvents.logPressableEventFromConfig(
      'walletSuccessScreenContinueButton',
      analyticsContext,
    );
    if (isBelieveDay0Flow === 'true' && believeAccountId) {
      router.dismissAll();
      router.replace(`/accounts/${believeAccountId}`);
    } else {
      router.back();
    }
  };

  useViewDidFocusScreenAnalyticsEvent({
    key: 'WalletProvisioningSuccessScreen',
    customAttributes: analyticsContext,
  });

  return (
    <SuccessScreen
      visual="CARD_A_ANIMATED"
      titleText={translatedText('title')}
      eyebrowText=""
      primaryButton={{
        label: translatedText('buttonText'),
        onPress: goBack,
      }}
      productOfferCard={requestedCard}
    />
  );
};

export default WalletProvisioningSuccessScreen;
